<template>
  <section>
    <header>
      <site-title :text="'Selected Works'" :textDelay="0.5" />
      <text-block :revealTransition="true" >Check out some of the works I've done in the last few years.</text-block>
    </header>
    <work-list listType="all" />
    <hr />
    <site-footer />
  </section>
</template>

<script>
import SiteTitle from '@/components/SiteTitle.vue'
import TextBlock from '@/components/TextBlock.vue'
import Footer from '@/components/Footer.vue'
import WorkList from '@/components/WorkList.vue'

export default {
  name: 'works',
  components: {
    'site-title': SiteTitle,
    'text-block': TextBlock,
    'site-footer': Footer,
    'work-list': WorkList
  }
}
</script>

<style lang="scss" scoped>
  section {
    width: 100%;
    max-width: $size-max-width;
    margin: 0 auto;

    @include device(laptop) {
      padding: 0 60px;
    }

    @include device(mobile) {
      padding: 0 20px;
    }
  }

  header {
    height: 60vh;
    min-height: 600px;
    max-height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    @include device(tablet) {
      height: 80vh;
    }

    @include device(mobile) {
      min-height: 400px;
    }
  }

  h2 {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    align-items: flext-start;
    cursor: default;
    max-width: 420px;
    color: $color-darkgrey;
  }

  hr {
    background: none;
    border: none;
    margin: 100px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Works.vue